import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import StepperCard from "../StepperCard";
import { CustomStepConnector, StepIcon, useSteps  } from "../StepperComponents"; // Import steps
import { useSelector, useDispatch } from 'react-redux';
import { bankOcrCheck, fnoDoLater, setActiveStep, setFnOStatusDoLater, updateNetWorth, uploadFnoDoc } from "../../../Redux/usersSlice";
import { useState,useRef, useEffect } from "react";
import navLogo from "../../../Assets/Images/logo.svg"

import {
  Box,
  FormControlLabel,
  Typography,
  Button,
  TextField,
  Radio,
  Grid2,
  Grid,
  styled,
  Modal,
  useMediaQuery,
  IconButton
} from "@mui/material";

import { FileUploader } from "react-drag-drop-files";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import BSstyles from "./ActivateFnO.module.css";
import collab from '../../../Assets/Images/collab1.svg';
import omImg from "../../../Assets/Images/oneMoney.png";
import * as CryptoJS from "crypto-js";
import { useSearchParams} from "react-router-dom";
import * as pdfjsLib from "pdfjs-dist"; // For handling PDF decryption using pdfjs-dist
import { ArrowBack } from "@mui/icons-material";
pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js";


export default function ActivateFnO() {
    const steps = useSteps();
  const navigate = useNavigate();
  const location = useLocation();

  const [networth, setNetworth] = useState(""); // Net worth input
  const [netErr, setNetErr] = useState(""); // Net worth error state
   const [selectedOption, setSelectedOption] = useState("Bank_Statement"); // Selected proof
  //  const [showOtherDocuments, setShowOtherDocuments] = useState(false); // Toggle for other docs
  const [uploadMethod, setUploadMethod] = useState("manual"); // Upload method for bank statement
   const [step, setStep] = useState(1); // Step control (1: Select Proof, 2: Upload File)
   const [bankStatmentFileName, setBankStatmentFileName] = useState("");
 const [passwordEnterErr, setPassEnterErr] = useState("");
  const [bankStatementFormData, setBankStatementFormData] = useState("");
  const [bankStatmentData, setBankStatmentData] = useState("");
   const [validated, setValidated] = useState(false);
    const [showfnolodder,setShowfnolodder]=useState(true)
     const [password, setPassword] = useState("");
     const [incorrectErr, setInccorectErr] = useState("");
     const modalPromiseRef = useRef(null);
     const [open, setOpen] = useState(false);
     const [showlodder, setShowLodder] = useState(false);
     const [opendoLater,setOpenDoLaterMessage]=useState(false)
     const [showOtherDocuments, setShowOtherDocuments] = useState(false); // Toggle for other docs
     const [banknotVerified,setbanknotVerfied]=useState(false)
 

  const dispatch = useDispatch();

  const { activeStep, userData, loading, bankData, bankDetails, is_verified,source } = useSelector( state => state.user);

  const backendResponse=userData.steps


      const isMobile = useMediaQuery('(max-width:1000px)');

      // useEffect(()=>{},[])

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "activatefno_page_viewed",
      page_path: window.location.pathname
    });
    console.log(is_verified)
    console.log(bankDetails?.ifsc_code)
    console.log(bankData?.is_verified)
    console.log(bankData?.ifsc_code)
    if ((is_verified === 1 && bankDetails?.ifsc_code)|| (bankData?.is_verified === 1 && bankData?.ifsc_code)) {
      setbanknotVerfied(false)
      console.log("Bank verified")
    } else {
      setbanknotVerfied(true)
      console.log("Bank not verified")
    }

  }, [])

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '60%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '400px' }, // Responsive width
    bgcolor: 'background.paper',
    borderRadius: '12px', // Rounded corners
    boxShadow: 24,
    p: 4,
    outline: 'none', // Remove default focus outline
    maxWidth: 'calc(100% - 32px)', // Prevent touching screen edges
    '@media (max-width:1200px)': {
      left: '55%',
    },
    '@media (max-width:1000px)': {
      left: '50%',
    },
    '@media (max-width:600px)': {
      width: '80%',
      p: 3,
    },
  };
  
  const buttonStyle = {
    mt: 3,
    display: 'flex',
    justifyContent: 'center',
    gap: 2, // Space between buttons
  };
  
  const primaryButton = {
    backgroundColor: '#f3d45e',
    color: 'black',
    padding: '8px 26px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily:"Inter400",
    textTransform: 'Capitalize',
    letterSpacing: '0.5px',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  };
  
  const secondaryButton = {
    backgroundColor: 'transparent',
    color: '#000',
    padding: '8px 16px',
    borderRadius: '4px',
    border: '1px solid #000',
    cursor: 'pointer',
    fontSize: '14px',
   fontFamily:"Inter400",
    // textTransform: 'uppercase',
    letterSpacing: '0.5px',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.04)',
      border: '1px solid #000',
    },
  };

  // Sync step with URL path
  React.useEffect(() => {
    const currentStep = steps.findIndex(
      (step) => step.path === location.pathname
    );
    if (currentStep !== -1)  dispatch(setActiveStep(currentStep));
  }, [location.pathname, setActiveStep]);



  const handleClose = () => setOpenDoLaterMessage(false);

      // Custom Radio Button Styling
      const CustomRadio = styled(Radio)(({ theme }) => ({
        "& .MuiButtonBase-root": {
          padding: "8px", // Adjust padding for spacing
        },
    
        "& .MuiSvgIcon-root": {
          width: 24, // Outer circle size
          height: 24,
          borderRadius: "50%",
          border: "1px solid #000", // Black border for outer circle
          backgroundColor: "#fff", // Default background
        },
    
        "& .MuiSvgIcon-root path": {
          display: "none", // Hides the default inner dot
        },
    
        "&.Mui-checked .MuiSvgIcon-root": {
          color: "#F3D45E", // Yellow fill for checked state
          borderRadius: "50%",
          border: "1px solid #000", // Keeps outer black border when checked
          width: 24,
          height: 24,
          transition: "all 0.3s ease", // Smooth transition
        },
    
        "&.Mui-checked .MuiSvgIcon-root path": {
          display: "block", // Ensure the inner dot is visible when checked
          fill: "#F3D45E", // Make the inner dot yellow
        },
    
        // Media queries for responsiveness
        "@media (max-width: 780px)": {
          "& .MuiSvgIcon-root": {
            width: 24,
            height: 24,
          },
          "&.Mui-checked .MuiSvgIcon-root": {
            width: 24,
            height: 24,
          },
        },
    
        "@media (max-width: 600px)": {
          "& .MuiSvgIcon-root": {
            width: 20,
            height: 20,
          },
          "&.Mui-checked .MuiSvgIcon-root": {
            width: 20,
            height: 20,
          },
        },
    
        "@media (max-width: 500px)": {
          "& .MuiSvgIcon-root": {
            width: 18,
            height: 18,
          },
          "&.Mui-checked .MuiSvgIcon-root": {
            width: 18,
            height: 18,
          },
        },
    
        "@media (max-width: 400px)": {
          "& .MuiSvgIcon-root": {
            width: 18,
            height: 18,
          },
          "&.Mui-checked .MuiSvgIcon-root": {
            width: 18,
            height: 18,
          },
        },
    
        "@media (max-width: 320px)": {
          "& .MuiSvgIcon-root": {
            width: 16,
            height: 16,
          },
          "&.Mui-checked .MuiSvgIcon-root": {
            width: 16,
            height: 16,
          },
        },
      }));
  
  // Handle checkbox selection (only one at a time)
  const handleCheckboxChange = (option) => {
    setSelectedOption(option);
  };

  const handlePasswordSubmit = (enteredPassword) => {
    console.log(enteredPassword);
    if (enteredPassword === "") {
      // setError({ errType: 2, errMsg: "Please Enter the Password" });
      console.log("Please Enter the Password");
      setPassEnterErr("Please Enter the Password");
    } else {
      setPassword(enteredPassword);
      setPassEnterErr("");

      // onClose(); // Closing the modal
      setOpen(false);

      if (modalPromiseRef.current && modalPromiseRef.current.resolve) {
        modalPromiseRef.current.resolve(enteredPassword);
      }
    }
  };

  const handleCancel = () => {
    // if (modalPromiseRef) {
    //   modalPromiseRef.reject();
    // }
    setOpen(false);
    setBankStatmentFileName("");
    setPassEnterErr("");
    setPassword("");
    setBankStatementFormData("");
  };

  
  const handleProceed = async() => {
    if (!networth) {
      setNetErr("Net worth is required!");
      return;
    }else if(networth<=0){
      setNetErr("Net worth is Invalid!");
      return;
    }

    const payload={
      email:userData.email.toLowerCase(),
      mobile:userData.mobile,
      net_worth:networth.replaceAll(",", "")
    }

    dispatch(updateNetWorth(payload)).unwrap();

    setNetErr(""); // Clear error if valid
    setStep(2); // Move to the next step (Upload File)

  };

  // Back to selection step
  const handleBack = () => {
    setStep(1);
    setBankStatmentFileName("");
    setPassEnterErr("");
    setPassword("");
    setBankStatementFormData("");
    setBankStatmentData("")
    setInccorectErr("")
    setValidated(false)
  };

  const handleProceedOneMoney = async () => {

}


const handleUpload = async (pdfBase64,pass) => {
  console.log("handleUpload",pass)
  try {
    console.log("bankStatementFormDataPic", bankStatementFormData);
    console.log("pdfBase64", pdfBase64);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "activatefno_upload",
      page_path: window.location.pathname
    });
     
    const payload = {
      email: userData.email.toLowerCase(),
      mobile: userData.mobile,
      document_type: selectedOption,
      base64: selectedOption == "Bank_Statement" ? pdfBase64 :bankStatmentData,
      password: pass
    };
        console.log("payload",payload)

    // Wait for the dispatch to complete and unwrap the response
    const response = await dispatch(uploadFnoDoc(payload)).unwrap();

    console.log(response)
    console.log(response.data.data.success)

    if (response.data.data.success) {
      dispatch(setFnOStatusDoLater());
      
      // First check if there are incomplete steps forward (normal flow)
      let nextIncompleteStep = null;

      // Check forward steps first
      for (let i = activeStep + 1; i < steps.length; i++) {
        const step = steps[i];
        const isComplete = step.substeps
          ? step.substeps.every(sub => userData.steps[sub.name]?.status)
          : userData.steps[step.name]?.status;
        console.log("Forward steps completed --->", isComplete);

        if (!isComplete) {
          nextIncompleteStep = step;
          console.log("Forward steps Incomplete navigating to", JSON.stringify(step));
          break;
        }
      }

      // If no incomplete steps forward, check all steps
      if (!nextIncompleteStep) {
        console.log("No incomplete steps forward checking any in backward steps");
        for (let i = 0; i < steps.length; i++) {
          const step = steps[i];
          const isComplete = step.substeps
            ? step.substeps.every(sub => userData.steps[sub.name]?.status)
            : userData.steps[step.name]?.status;

          if (!isComplete) {
            nextIncompleteStep = step;
            console.log("Backward steps Incomplete navigating to", JSON.stringify(step));
            break;
          }
        }
      }

      const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep?.path);
      console.log("Navigating to the specific step according to the condition", stepIndex);
      
      if (stepIndex !== -1 && nextIncompleteStep) {
        dispatch(setActiveStep(stepIndex));
        navigate(nextIncompleteStep.path);
      }
    } else {
      HandleReset();
      setValidated(false);
      setInccorectErr(response.data.data.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Validation error:", error);
    HandleReset();
    setValidated(false);
    setInccorectErr(error.message || "Something went wrong");
  }
};

  const handleUploadGrey=()=>{
      
    if (bankStatmentFileName == "") {
      setInccorectErr("Please select the file");
      setShowLodder(false);
      return;
    }

  }

  const handleNextStepDoLater = async () => {
    try {
      const payload = {
        email: userData.email.toLowerCase(),
        mobile: userData.mobile
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "activatefno_skipped",
        page_path: window.location.pathname
      });
  
      // Dispatch and unwrap the response to properly handle errors
      const response = await dispatch(fnoDoLater(payload)).unwrap();
  
      if (response?.data?.data?.success) {
        dispatch(setFnOStatusDoLater());
  
        // First check if there are incomplete steps forward (normal flow)
        let nextIncompleteStep = null;
  
        // Check forward steps first
        for (let i = activeStep + 1; i < steps.length; i++) {
          const step = steps[i];
          const isComplete = step.substeps
            ? step.substeps.every(sub => userData.steps[sub.name]?.status)
            : userData.steps[step.name]?.status;
          
          console.log(`Step ${step.name} completed:`, isComplete);
  
          if (!isComplete) {
            nextIncompleteStep = step;
            console.log("Found incomplete step:", step.name);
            break;
          }
        }
  
        // If no incomplete steps forward, check all steps
        if (!nextIncompleteStep) {
          console.log("Checking all steps for incomplete status");
          for (let i = 0; i < steps.length; i++) {
            const step = steps[i];
            const isComplete = step.substeps
              ? step.substeps.every(sub => userData.steps[sub.name]?.status)
              : userData.steps[step.name]?.status;
  
            if (!isComplete) {
              nextIncompleteStep = step;
              console.log("Found incomplete step in full check:", step.name);
              break;
            }
          }
        }
  
        // Safely handle navigation
        if (nextIncompleteStep) {
          const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
          console.log("Navigating to step index:", stepIndex);
          
          if (stepIndex !== -1) {
            dispatch(setActiveStep(stepIndex));
            navigate(nextIncompleteStep.path);
          } else {
            console.warn("Step path not found in steps array");
            // Fallback navigation or error handling
          }
        } else {
          console.log("All steps are complete");
          // Handle case when all steps are complete
        }
      } else {
        console.error("API success flag was false");
        // Handle API response indicating failure
        throw new Error(response?.data?.response?.message || "Request failed");
      }
    } catch (error) {
      console.error("Error in handleNextStepDoLater:", error);
      // You might want to:
      // 1. Show an error message to the user
      // 2. Reset any loading states
      // 3. Perform cleanup if needed
      
      // Example error handling:
      // setErrorState(error.message || "An error occurred");
      // setIsLoading(false);
    }
  };

  const HandleReset = () => {
    // Handle reset logic here if necessary
    console.log("hell0011")
    setBankStatmentFileName("");
    setPassEnterErr("");
    setPassword("");
    setBankStatementFormData("");
  };


  // const HandleFile = async (file) => {
  //   setBankStatmentFileName("");
  //   setBankStatementFormData("");
  //   setPassword("");
  //   setValidated(false);
  //   let data=""
  //   let fsize = (file.size / (1024 * 1024)).toFixed(2);
  //   console.log(file.type, "file type");
  
  //   if (file.type !== "application/pdf") {
  //     setInccorectErr("Invalid File Format for Bank Statement (Only PDF supported)");
  //     console.log("Invalid File Format for Bank Statement (Only PDF supported)");
  //     return;
  //   } else if (fsize > 20) {
  //     setInccorectErr("Max 20MB allowed");
  //     console.log("Max 20MB allowed");
  //     return;
  //   } else {
  //     const processFirstPage = async (pdfDoc) => {
  //       try {
  //         const firstPage = await pdfDoc.getPage(1);
  //         const firstPageCanvas = document.createElement("canvas");
  //         const context = firstPageCanvas.getContext("2d");
  //         const viewport = firstPage.getViewport({ scale: 1 });
  
  //         firstPageCanvas.height = viewport.height;
  //         firstPageCanvas.width = viewport.width;
  
  //         await firstPage.render({ canvasContext: context, viewport }).promise;
  
  //         const base64PdfImage = firstPageCanvas.toDataURL();
  //         setInccorectErr("");

  //         if(selectedOption=="Bank_Statement"){
  //           setBankStatementFormData(base64PdfImage);
  //           console.log(base64PdfImage)
  //             // Call validate directly without useEffect
  //           await handleValidate(base64PdfImage);
  //         }
          
  //         // ✅ Automatically trigger validation after file processing
  //         // handleValidate();




  //       } catch (error) {
  //         console.error("❌ Error extracting first page:", error);
  //         setInccorectErr("Failed to extract the first page of the PDF");



  //         setOpen(false);
  //         HandleReset();
  //       }
  //     };
  
  //     const bs = async () => {
  //       const fileReader = new FileReader();
  //       fileReader.onload = async () => {
  //         console.log("Function running in AA");
  //         const pdfBytes = new Uint8Array(fileReader.result);
  //         let pdfDoc;
  //         let isPasswordRequired = false;
  
  //         try {
  //           const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
  //           pdfDoc = await loadingTask.promise;
  
  //           // ✅ Process first page & validate immediately
  //           await processFirstPage(pdfDoc);
  //           return;
  //         } catch (error) {
  //           console.error("Error processing PDF:", error);
  //           if (error.message === "No password given") {
  //             console.log("🔑 PDF is password protected.");
  //             isPasswordRequired = true;
  //           } else {


  //             setOpen(false);
  //             setInccorectErr("Incorrect password or the PDF file is inaccessible. Please check your password and ensure the file is not corrupted or restricted");
  //             HandleReset();
  //             return;
  //           }
  //         }
  
  //         if (isPasswordRequired) {
  //           setOpen(true);
  //           setPassword("");
  //           setInccorectErr("");
  
  //           try {
  //             const promise = new Promise((resolve, reject) => {
  //               modalPromiseRef.current = { resolve, reject };
  //             });
  
  //             const enteredPassword = await promise;
  //             console.log("🔓 Password entered:", enteredPassword);
  
  //             const decryptedLoadingTask = pdfjsLib.getDocument({
  //               data: pdfBytes,
  //               password: enteredPassword,
  //             });
  
  //             pdfDoc = await decryptedLoadingTask.promise;
  //             console.log("PDF decrypted successfully.");
  //             setOpen(false);
  
  //             await processFirstPage(pdfDoc);
  //           } catch (decryptError) {
  //             console.error("Unable to decrypt PDF with provided password:", decryptError);
  //             setOpen(false);
  //             setInccorectErr("Incorrect password or the PDF file is inaccessible.");
  //             HandleReset();
  //           }
  //         }
  //       };
  //       fileReader.readAsArrayBuffer(file);
  //     };
  
  //     await bs();
  //     const base64 = await ConvertBase64(file);
  //     console.log(base64);
  //     setBankStatmentFileName(file.name);
  //     setBankStatmentData(base64);
  //   }
  // };

  const HandleFile = async (file) => {
    // Reset all states before processing
    setBankStatmentFileName("");
    setBankStatementFormData("");
    setPassword("");
    setValidated(false);
    setInccorectErr("");
    let pdfPassword=""
    let fsize = (file.size / (1024 * 1024)).toFixed(2);

    console.log("File type:", file.type);

    // Validate file type & size
    if (file.type !== "application/pdf") {
      setInccorectErr("Invalid File Format for Bank Statement (Only PDF supported)");
      return;
    } else if (fsize > 20) {
      setInccorectErr("Max 20MB allowed");
      return;
    }

    /**
     * Helper to extract the first page as Base64 image
     */
    const processFirstPage = async (pdfDoc) => {
      return new Promise(async (resolve, reject) => {
        try {
          const firstPage = await pdfDoc.getPage(1);
          const firstPageCanvas = document.createElement("canvas");
          const context = firstPageCanvas.getContext("2d");
          const viewport = firstPage.getViewport({ scale: 1 });

          firstPageCanvas.height = viewport.height;
          firstPageCanvas.width = viewport.width;

          await firstPage.render({ canvasContext: context, viewport }).promise;

          const base64PdfImage = firstPageCanvas.toDataURL();
          console.log("First page extracted successfully");

          setBankStatementFormData(base64PdfImage); // store first-page image
          resolve(base64PdfImage); // return to parent
        } catch (error) {
          console.error("❌ Error extracting first page:", error);
          setInccorectErr("Failed to extract the first page of the PDF");
          setOpen(false);
          HandleReset();
          reject(error);
        }
      });
    };
    /**
     * Process PDF file (handle password protection + first page extraction)
     */
    const processPdf = (file) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = async () => {
          const pdfBytes = new Uint8Array(fileReader.result);
          let pdfDoc;
          let isPasswordRequired = false;
          try {
            const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
            pdfDoc = await loadingTask.promise;

            // Extract first page successfully
            const firstPageBase64 = await processFirstPage(pdfDoc);
            return resolve(firstPageBase64);
          } catch (error) {
            console.error("Error processing PDF:", error);
            if (error.message === "No password given") {
              console.log("🔑 PDF is password protected.");
              isPasswordRequired = true;
            } else {
              setOpen(false);
              setInccorectErr("Incorrect password or inaccessible PDF file.");
              HandleReset();
              return reject(error);
            }
          }
          if (isPasswordRequired) {
            setOpen(true);
            setPassword("");
            setInccorectErr("");
            try {
              const promise = new Promise((resolvePassword) => {
                modalPromiseRef.current = { resolve: resolvePassword };
              });
              const enteredPassword = await promise;
              pdfPassword=enteredPassword
              console.log("🔓 Password entered:", enteredPassword);
              const decryptedLoadingTask = pdfjsLib.getDocument({
                data: pdfBytes,
                password: enteredPassword,
              });
              pdfDoc = await decryptedLoadingTask.promise;
              console.log("PDF decrypted successfully.");
              setOpen(false);
              const firstPageBase64 = await processFirstPage(pdfDoc);
              resolve(firstPageBase64);
            } catch (decryptError) {
              console.error("Unable to decrypt PDF:", decryptError);
              setOpen(false);
              setInccorectErr("Incorrect password or the PDF file is inaccessible.");
              HandleReset();
              reject(decryptError);
            }
          }
        };

        fileReader.readAsArrayBuffer(file);
      });
    };
    try {
      // Step 1: Extract first page
      const firstPageImageBase64 = await processPdf(file);

      // Step 2: Convert full PDF to Base64
      const fullPdfBase64 = await ConvertBase64(file);

      setBankStatmentFileName(file.name);
      setBankStatmentData(fullPdfBase64);

      console.log("Full PDF Base64 ready");

      // Step 3: Call validation with both first-page image & full PDF
      if (selectedOption === "Bank_Statement" && firstPageImageBase64) {
        console.log("Calling handleValidate now...", pdfPassword);
        await handleValidate(firstPageImageBase64, fullPdfBase64, pdfPassword);
      } else {
        console.warn("Validation skipped: first page missing or option not selected");
      }
    } catch (error) {
      console.error("Error in HandleFile:", error);
    }
  };
  // Modified handleValidate to accept data directly
// const handleValidate = async (imageData = bankStatementFormData) => {
//   console.log("validate", imageData)
//   if (!imageData) return;
  
//   try {
//     const base64String = imageData.split(",")[1];
    
//     const payload = {
//       email: userData.email,
//       mobile: userData.mobile,
//       type: "bank_statment", 
//       filetype: "png",
//       base64: base64String,
//     };

//     console.log("Sending payload:", payload);
    
//     const response = await dispatch(bankOcrCheck(payload)).unwrap();
    
//     console.log("Full API response:", response);
    
//     if (response.data.response.status === true) {
//       setValidated(true);
//       console.log("Validation successful");
//       handleUpload()
//     } else if(response.data.response.status === false) {
//       HandleReset();
//       setValidated(false);
//       setInccorectErr(response.data.response.message || "Validation failed");
//     }
//   } catch (error) {
//     console.error("Validation error:", error);
//     HandleReset();
//     setValidated(false);
//     setInccorectErr("Something went wrong");
//   }
// };
  const handleValidate = async (imageData, pdfBase64,pass) => {
    console.log("handleValidate triggered",pass);

    if (!imageData) {
      console.error("❌ Validation failed: No image data provided");
      return;
    }

    try {
      // Clean Base64: remove data:image/png;base64,
      const base64String = imageData.split(",")[1];

      const payload = {
        email: userData.email.toLowerCase(),
        mobile: userData.mobile,
        type: "bank_statment",
        filetype: "png",
        base64: base64String,
      };

      console.log("Sending OCR payload:", payload);
      // Call OCR validation API
      const response = await dispatch(bankOcrCheck(payload)).unwrap();
      console.log("OCR response received:", response);

      if (response?.data?.response?.success === true) {
        setValidated(true);
        console.log("✅ Validation successful",password);
        // Upload the full PDF Base64
        handleUpload(pdfBase64, pass);
      } else {
        HandleReset();
        setValidated(false);
        setInccorectErr(response?.data?.response?.message || "Validation failed");
        console.warn("Validation failed:", response?.data?.response?.message);
      }
    } catch (error) {
      console.error("Validation error:", error);
      const errorMessage = error?.data?.data?.message
      HandleReset();
      setValidated(false);
      setInccorectErr(errorMessage || "Something went wrong during validation");
    }
  };

  


  const ConvertBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleNextStep =()=>{
    navigate("/step-3")
  
  }

  // Corresponding points for each option
  const optionDetails = {
    Bank_Statement: [
      "Upload last 6 months statement",
      "The statement should be of a verified bank on TradeBoss only",
      "At least one transaction of value > ₹10,000",
    ],
    Net_Worth: [
      "Should be of latest month only",
      "Should display the value of securities lying in demat account (it should be more than ₹10,000)",
    ],
    Demat_Statement: [
      "Should be of latest month only",
      "Should display the values of securities lying in demat account (it should be more than ₹10,000)",
    ],
    ITR: [
      "Gross annual income should be more than ₹1,20,000 lacs",
      "ITR Acknowledgement should be of last Financial Year",
    ],
    Salary_Slip: [
      "Should not be more than 2 months old",
      "Gross monthly salary should be more than ₹10,000",
    ],
    Form_16:[
      "Your full name and PAN number must be clearly visible",
      "The Form 16B should be from the latest assessment year"
    ]
  };

  const handleDolaterFnO=()=>{
    setOpenDoLaterMessage(true)
  }

  const handleStepNavigate = (path) => {
    const stepIndex = steps.findIndex((step) => step.path === path);
    if (stepIndex !== -1) {
       dispatch(setActiveStep(stepIndex));
      navigate(path);
    }
  };


  const handleStepBack = () => {
    // if (userData?.steps?.["DigiLocker KYC verified Docs"]?.status) {
    //   navigate("/step-2")
    // } else {
      navigate("/step-3")
    // }
  }

  return (
    <main>
    <Box sx={{
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      minHeight: "100vh",
      width: "100%", // Changed from 100vw to prevent horizontal scroll
      overflowX: "hidden", // Prevent horizontal overflow
      backgroundImage: `url(${SignUpBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
      }}>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontFamily: "Inter400",
          display: {
            xs: "block", // shown on small screens
          },
          mt:"5px",
          "@media (min-width:1000px)": {
            display: "none"
          }
        }}
      >
        {`You are on step ${activeStep+1} out of 8`}
      </Typography>


      <StepperCard
        activeStep={activeStep}
        handleStepNavigate={handleStepNavigate}
        backendResponse={backendResponse}
        CustomStepConnector={CustomStepConnector}
        StepIcon={StepIcon}
        steps={steps}
      />

      {/* Your content area */}
      <Box
        sx={{

        
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 3,
          width: "100%", // Ensure full width
          maxWidth: 720, // Max width constraint
          mx: "auto",
          boxSizing: "border-box", // Include padding in width calculations
          overflow: "hidden", // Prevent internal overflow

          "@media (max-width:1000px)": {
            paddingTop:0
          }
        }}
      >
        <>
          {/* Step 1: Proof Selection */}
          {step === 1 && (
            <>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                flexDirection:"column",
                width: '100%',
                marginBottom: '10px',
                marginTop: '0px',
              }}>
                {/* Back arrow button - only shows below 1000px */}
                <Box sx={{
                  position: 'absolute',
                  left: 0,

                  '@media (min-width: 1000px)': {
                    display: 'none' // Explicitly hide above 1000px
                  },
                  '@media (max-width: 510px)': {
                    marginBottom:"20px"
                  }
                }}>
                  <IconButton
                    onClick={handleStepBack} // Or your custom back handler
                    aria-label="Go back"
                    sx={{
                      color: '#000', // Customize color
                      padding: '16px',
                      '@media (max-width: 400px)': {
                        paddingLeft: "0px"
                      }
                      
                    }}
                  >
                    <ArrowBack /> {/* Make sure to import from @mui/icons-material */}
                  </IconButton>
                </Box>

                {/* Logo - centered */}
                <img
                  src={source == "cosmos" ? collab : navLogo}
                  alt="Logo"
                  className={source == "cosmos" ? BSstyles.twologo :
                    BSstyles.responsivelogo}
                  style={{
                    // Adjust margin to account for arrow on mobile
                    marginLeft: { xs: '40px', md: 0 }
                  }}
                />
                {
                  source == "cosmos" &&
                  <Typography className={BSstyles.txt1}>
                    Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                  </Typography>
                }
              </Box>
              <Typography
                sx={{
                  fontFamily: 'Inter900 !important',
                  fontSize: {
                    xs: '24px',  // mobile
                    sm: '32px',  // tablets
                    md: '45px',  // desktop
                  },
                  textAlign:"center",
                  color: '#481B9D !important',
                }}
              >
                Activate Future and Options
              </Typography>


              {/* Net Worth Input */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  mt: 1,
                  mb: 1,
                  width: "100% !important"
                }}
              >
                 <TextField
                        variant="outlined"
                        placeholder="Enter Your Net worth"
                        value={networth}
                        onChange={(e) => {
                          const raw = e.target.value.replace(/[^\d]/g, "").trim(); // Remove non-digits
                          const formatted = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas
                          setNetworth(formatted);
                        }}
                        error={!!netErr}
                        sx={{
                            backgroundColor: "white",
                            borderRadius: "39px",
                            // marginTop: "24px",
                            "@media (max-height:735px)": {
                                marginTop: "10px !important"
                            },
                            "& input": {
                                display: "flex",
                                alignItems: "center",
                                padding: "12px 12px",
                                textAlign: "center !important",
                                fontFamily: "Inter400 !important",
                                fontSize: "18px !important",
                                lineHeight: "21.78px !important",
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    borderRadius: "39px",
                                    height: "46px !important",
                                    width: "399px !impoertant",
                                    borderColor: "#D9D9D9",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#D9D9D9", // Keep border color consistent on hover
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#D9D9D9",
                                    borderWidth: "1px",
                                },
                            },
                            width: "399px",
                            height: "42px !important",
                            "@media (max-width: 1000px)": {
                                width: "316px",
                                height: "45px !important",
                                "& input": {
                                    fontSize: "18px !important",
                                },
                                "& .MuiOutlinedInput-root fieldset": {
                                    height: "50px !important",
                                    width: "299px !important",
                                },
                            },
                        }}
                    />

                {netErr && (
                  <span
                    style={{
                      color: "#FF0000",
                      fontSize: "12px",
                    }}
                  >
                    {netErr}
                  </span>
                )}
              </Box>

              <Typography
                sx={{
                  fontFamily: "Inter400",
                  fontSize: {
                    xs: "14px",  // Mobile (under 600px)
                    sm: "16px",  // Tablet (600px and up)
                    md: "18px",  // Desktop (900px and up)
                  },
                  mt: 2,
                  textAlign:"center"
                }}
              >
                Please submit any of the below proof for activating FNO
              </Typography>


              {/* Bank Statement (Always Visible) */}
              <Box
                sx={{
                  mt: 2,
                  padding:"8px 8px 16px 16px !important",
                  backgroundColor: "#ffffff !important",
                  borderRadius: "14px !important",
                  border:"1px solid #D9D9D9 !important",
                  cursor: "pointer",
                  width: "100%",  // Default width
                  maxWidth: "620px",  // Max width constraint
                 
                
                }}
                onClick={() => handleCheckboxChange("Bank_Statement")}
              >
                <FormControlLabel
                  control={
                    <CustomRadio
                      checked={selectedOption === "Bank_Statement"}
                      onChange={() => handleCheckboxChange("Bank_Statement")}
                      value="Bank_Statement"
                      sx={{
                        '& .MuiSvgIcon-root': {
                          fontSize: 28,
                        },
                        
                      }}
                    
                    />
                    
                  }
                  label="Bank Statement"
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: "Inter400", // 👉 change to your desired font
                      fontSize:"16px !important"
                    
                    },}}
                />
                {selectedOption === "Bank_Statement" && (
                  <Box
                    component="ul"
                    sx={{
                      pl: 7,
                      // mt: 1,
                      m:0,
                      listStyleType: "disc",
                      // Responsive styles
                      "@media (max-width: 700px)": {
                        paddingLeft: 6, // Reduce indentation for smaller screens
                        fontSize: "14px", // Smaller font
                      },
                      "@media (max-width: 480px)": {
                        paddingLeft: 5,
                        fontSize: "13px",
                      },
                    }}
                  >
                    {optionDetails.Bank_Statement.map((point, index) => (
                      <Box
                        component="li"
                        key={index}
                        sx={{
                          fontSize: "14px",
                          fontFamily:"Inter400 !important",
                          color: "#000",
                          // Responsive styles for list items
                          "@media (max-width: 700px)": {
                            fontSize: "12px",
                          },
                          "@media (max-width: 450px)": {
                            fontSize: "11px",
                          },
                        }}
                      >
                        {point}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              {/* Other Options */}

              <Box sx={{ mt: 2 }}>
                    <Typography
                      component="span"
                      onClick={() => setShowOtherDocuments(!showOtherDocuments)}
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 1,
                        color: selectedOption !== "Bank_Statement" ? "#481B9D" : "#000",
                        cursor: "pointer",
                        fontFamily:"Inter400"
                      }}
                    >
                      Or, show other eligible documents
                      {showOtherDocuments ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </Typography>
                  </Box>

                  {/* Other Documents */}
                  {showOtherDocuments && (
                    <>
              {[
                { name: "Net_Worth", label: "Net Worth Certificate" },
                { name: "Demat_Statement", label: "DP Holding Statement" },
                { name: "ITR", label: "IT Return (Last Year)" },
                { name: "Salary_Slip", label: "Salary Slip (Last Month)" },
                { name: "Form_16", label: "Form 16B (Latest year)" }
              ].map((item) => (
                <Box
                  key={item.name}
                  sx={{
                    mt: 1,
                    padding:"8px 8px 16px 16px !important",
                    backgroundColor: "#ffffff !important",
                    borderRadius: "14px !important",
                    border:"1px solid #D9D9D9 !important",
                    cursor: "pointer",
                    width: "100%",  // Default width
                    maxWidth: "620px",  // Max width constraint
                   
                  }}
                  onClick={() => handleCheckboxChange(item.name)}
                >
                  <FormControlLabel
                    control={
                      <CustomRadio
                        checked={selectedOption === item.name}
                        onChange={() => handleCheckboxChange(item.name)}
                        value={item.name}
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 28,
                          },
                        }}
                        
                      />
                    }
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontFamily: "Inter400", // 👉 change to your desired font
                        fontSize:"16px !important"
                      
                      },}}
                    label={item.label}
                  />
                  {selectedOption === item.name && (
                    <Box sx={{ pl: 4}}>
                      <Box
                        component="ul"
                        sx={{
                          pl: 3, // Default padding left
                          m:0,
                          listStyleType: "disc",
                         
                          // Responsive styles
                          "@media (max-width: 700px)": {
                            pl: 2, // Reduce indentation for smaller screens
                            fontSize: "14px", // Smaller font
                          },
                          "@media (max-width: 480px)": {
                            pl: 1,
                            fontSize: "13px",
                          },
                        }}
                      >
                        {optionDetails[item.name].map((point, index) => (
                          <Box
                            component="li"
                            key={index}
                            sx={{
                              fontSize: "14px",
                              fontFamily:"Inter400",
                              color: "#000",
                              // Responsive styles for list items
                              "@media (max-width: 700px)": {
                                fontSize: "12px",
                              },
                              "@media (max-width: 450px)": {
                                fontSize: "11px",
                              },
                            }}
                          >
                            {point}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
              </>
 )}
              <Typography
                sx={{
                  fontFamily: "Inter400",
                  fontSize: "13px",
                  mt: 4,
                  textAlign: "left",
                  // Responsive media queries
                  '@media (max-width: 1200px)': {
                    fontSize: '14px', // Adjust font size for medium screens
                  },
                  '@media (max-width: 900px)': {
                    fontSize: '12px', // Adjust font size for smaller screens
                    mt: 3, // Adjust margin-top
                  },
                  '@media (max-width: 600px)': {
                    fontSize: '11px', // Smaller font size for mobile
                    mt: 2, // Adjust margin-top
                  },
                }}
              >
                As per SEBI & Exchange regulations, you are required to
                share your proof of income to enable trading in Futures &
                Options.
              </Typography>

              {/* Proceed Button (Aligned to Right) */}
              <Box
                sx={{
                  mt: 4,
                  mb: 4,
                  display: 'flex',
                  justifyContent: 'center',
                  flexWrap: { xs: 'wrap-reverse', sm: 'nowrap' }, // ✅ wrap on mobile, no-wrap on larger screens
                  gap: 2, // spacing between buttons
                }}
              >
                <Button
                  className={BSstyles.skip_button}
                  variant="outlined"
                  onClick={handleDolaterFnO}
                  sx={{
                    width: { xs: '100%', sm: 'auto' }, // ✅ full width on mobile
                  }}
                >
                  Do It Later
                </Button>

                <Button
                  variant="contained"
                  onClick={handleProceed}
                  className={BSstyles.con_button}
                  sx={{
                    width: { xs: '100%', sm: 'auto' }, // ✅ full width on mobile
                  }}
                >
                  Continue
                </Button>
              </Box>

            </>
          )}

          {/* Step 2: File Upload */}
          {step === 2 && (
            <>

              <img src={source == "cosmos" ? collab : navLogo}
                alt="Logo"
                className={source == "cosmos" ? BSstyles.twologo :
                  BSstyles.responsivelogo} style={{ marginBottom: "20px",marginTop:"25px" }} />
              {
                source == "cosmos" &&
                <Typography className={BSstyles.txt1}>
                  Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                </Typography>
              }
              <Typography
                sx={{
                  fontFamily: "Inter500 !important",
                  fontSize: { xs: "24px", sm: "24px", md: "28px", lg: "34px" }, // Responsive font sizes
                  textAlign: "center !important",
                  marginTop:"25px"
                }}
              >
                Upload{" "}
                {[
                  { name: "Bank_Statement", label: "Bank Statement" },
                  { name: "Net_Worth", label: "Net Worth Certificate" },
                  { name: "Demat_Statement", label: "DP Holding Statement" },
                  { name: "ITR", label: "IT Return (Last Year)" },
                  { name: "Salary_Slip", label: "Salary Slip (Last Month)" },
                  { name: "Form_16", label: "Form 16B (Latest year)" }
                ].find((item) => item.name === selectedOption)?.label ||
                  "Selected Proof"}
              </Typography>

              {/* Special Case: Bank Statement (Show Upload Methods) */}
              {selectedOption === "Bank_Statement" ? (
                <>
                  <Typography className={BSstyles.sub_text}>
                    As per the regulatory requirements, we would need six months
                    bank statement of the applicant.
                  </Typography>

                  {/* Radio Selection (Centered) */}
                  {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <RadioGroup
                      className={BSstyles.radio_group}
                      value={uploadMethod}
                      onChange={(e) => setUploadMethod(e.target.value)}
                    >
                      <FormControlLabel
                        value="manual"
                        control={<CustomRadio />}
                        label={
                          <Typography className={BSstyles.radioText}>
                            Upload Manually
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="digital"
                        control={<CustomRadio />}
                        label={
                          <Typography className={BSstyles.radioText}>
                            Digitally fetch your bank statement
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </Box> */}

                  {/* Upload Box */}
                  {uploadMethod === "manual" ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          marginTop: "32px !important",
                          marginBottom: "5px !important"
                        }}
                      >
                        {/* File Upload Box */}
                        <FileUploader
                          multiple={false}
                          maxSize={"1mb"}
                          hoverTitle="rAI"
                          label="Upload or drop a file right here"
                          handleChange={(file) => {
                            if (!loading) {  // Only handle changes when not loading
                              HandleFile(file);
                            }
                          }}
                          name="file"
                          disabled={loading}  // This disables the file uploader
                        >
                          <Box className={BSstyles.upload_box}>
                            <Box
                              sx={{
                                height: "60px",
                                display: "flex",
                                alignItems: "center",
                                opacity: loading ? 0.6 : 1,  // Visual feedback when disabled
                                pointerEvents: loading ? 'none' : 'auto',  // Prevent interactions
                                cursor: loading ? 'not-allowed' : 'pointer'  // Change cursor
                              }}
                            >
                              <Typography className={BSstyles.dragdropstyle}>
                                Drag and Drop here /{" "}
                                <span className={BSstyles.browse_text}>
                                  {loading ? "Processing..." : "Browse File"} 
                                </span>
                              </Typography>
                            </Box>
                          </Box>
                        </FileUploader>
                      </Box>
                      {(bankStatmentFileName || incorrectErr) && (
                        <Box
                          sx={{
                            display: "flex !important",
                            justifyContent: "center !important",
                            marginTop: "25px",
                          }}
                        >
                          <Grid
                            container
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-around",
                              "@media only screen and (max-device-width: 899px)":
                              {
                                width: "90%",
                              },
                            }}
                          >
                            <Grid item style={{ textAlign: "left" }}>
                              <Grid2 className="desktopUpload">
                                <Grid2
                                  style={{ width: "100%", textAlign: "center" }}
                                >
                                  {bankStatmentFileName && (
                                    <Typography
                                      sx={{
                                        "@media only screen and (max-device-width: 460px)":
                                        {
                                          fontSize: "12px !important",
                                        },
                                      }}
                                    >
                                      {bankStatmentFileName}
                                    </Typography>
                                  )}
                                  {incorrectErr && (
                                    <Typography
                                      sx={{
                                        fontSize: "12px !important",
                                        color: "red !important",
                                      }}
                                    >
                                      {incorrectErr}
                                    </Typography>
                                  )}
                                </Grid2>
                              </Grid2>
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                    </>
                  ) : (
                    <Box>
                      <Grid2 className={BSstyles.img_card}>
                        <img
                          src={omImg}
                          alt="omimg"
                          className={BSstyles.om_img}
                        ></img>
                      </Grid2>
                      <Grid2 sx={{ padding: "0px 30px !important" }}>
                        <Typography className={BSstyles.omtext}>
                          BullForce works with onemoney, on RBI registered
                          account aggregator to securly fetch your data. You
                          will be registered to the onemoney website to provide
                          consent
                        </Typography>
                      </Grid2>
                    </Box>
                  )}

                  {/* Buttons */}
                  <Box className={BSstyles.but_card}>
                    {uploadMethod === "manual" ? (
                      <>
                       <Button
                        className={BSstyles.backBtn}
                        onClick={() => handleBack()}
                        disabled={loading}
                        sx={{
                          opacity: loading ? 0.6 : 1,
                          pointerEvents: loading ? "none" : "auto",
                        }}
                      >
                       Back
                      </Button>
                        {/* {validated ? <Button
                          className={BSstyles.up_button}
                          onClick={() => handleUpload()}
                        >
                          { loading ? "Uploading..." : "Upload"}
                        </Button> : <Button
                          className={BSstyles.grey_button}
                          onClick={() => handleUploadGrey()}
                        >
                         { loading ? "verifying..." : "Upload"}
                        </Button>
                        } */}
                      </>
                    ) : (
                      <>
                        <Button
                          className={BSstyles.backBtn}
                          onClick={() => handleBack()}
                        >
                          Back
                        </Button>
                        <Button className={BSstyles.Acon_button} onClick={handleProceedOneMoney}>
                          Proceed
                        </Button>
                      </>
                    )}
                  </Box>

                  {/* Security Notice */}
                  <Typography
                    sx={{
                      fontFamily: "Inter400",
                      fontSize: "13px",
                      mt: 4,
                      textAlign: "center",
                      // Responsive media queries
                      '@media (max-width: 1200px)': {
                        fontSize: '14px', // Adjust font size for medium screens
                      },
                      '@media (max-width: 900px)': {
                        fontSize: '12px', // Adjust font size for smaller screens
                        mt: 3, // Adjust margin-top
                      },
                      '@media (max-width: 600px)': {
                        fontSize: '11px', // Smaller font size for mobile
                        mt: 2, // Adjust margin-top
                      },
                    }}
                  >
                    As per SEBI & Exchange regulations, you are required to
                    share your proof of income to enable trading in Futures &
                    Options.
                  </Typography>
                </>
              ) : (
                <>
                  {" "}
                  {/* File Uploader */}
                  <Typography className={BSstyles.sub_text}>
                    {[
                      {
                        name: "Bank_Statement",
                        statement:
                          " As per the regulatory requirements, we would need six months bank statement of the applicant ",
                      },
                      {
                        name: "Net_Worth",
                        statement:
                          "As per regulatory requirements, we need the latest month's demat account statement showing securities valued at more than ₹10,000.",
                      },
                      {
                        name: "Demat_Statement",
                        statement:
                          "As per regulatory requirements, we need the latest month's demat account statement showing securities valued at more than ₹10,000.",
                      },
                      {
                        name: "ITR",
                        statement:
                          "As per regulatory requirements, we need the ITR Acknowledgement for the last financial year and proof of a gross annual income exceeding ₹1,20,000 lacs.",
                      },
                      {
                        name: "Salary_Slip",
                        statement:
                          "As per regulatory requirements, the document should not be more than 2 months old and must show a gross monthly salary exceeding ₹10,000",
                      },
                      {
                        name: "Form_16",
                        statement:
                          "As per regulatory requirements, your full name and PAN number must be clearly visible, and the Form 16B should be from the latest assessment year.",
                      },
                    ].find((item) => item.name === selectedOption)?.statement ||
                      "Selected Proof"}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      marginTop: "32px !important",
                      marginBottom: "5px !important"
                    }}
                  >
                    {/* File Upload Box */}
                    <FileUploader
                      multiple={false}
                      maxSize={"1mb"}
                      hoverTitle="rAI"
                      label="Upload or drop a file right here"
                      handleChange={(file) => {
                        HandleFile(file);
                      }}
                      name="file"
                    >
                      <Box className={BSstyles.upload_box}>
                        <Box
                          sx={{
                            height: "60px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography className={BSstyles.dragdropstyle}>
                            Drag and Drop here /{" "}
                            <span className={BSstyles.browse_text}>
                              Browse File
                            </span>
                          </Typography>
                        </Box>
                      </Box>
                    </FileUploader>
                  </Box>
                  {(bankStatmentFileName || incorrectErr) && (
                    <Box
                      sx={{
                        display: "flex !important",
                        justifyContent: "center !important",
                        marginTop: "25px",
                      }}
                    >
                      <Grid
                        container
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-around",
                          "@media only screen and (max-device-width: 899px)": {
                            width: "90%",
                          },
                        }}
                      >
                        <Grid item style={{ textAlign: "left" }}>
                          <Grid2 className="desktopUpload">
                            <Grid2
                              style={{ width: "100%", textAlign: "center" }}
                            >
                              {bankStatmentFileName && (
                                <Typography
                                  sx={{
                                    "@media only screen and (max-device-width: 460px)":
                                    {
                                      fontSize: "12px !important",
                                    },
                                  }}
                                >
                                  {bankStatmentFileName}
                                </Typography>
                              )}
                              {incorrectErr && (
                                <Typography
                                  sx={{
                                    fontSize: "12px !important",
                                    color: "red !important",
                                  }}
                                >
                                  {incorrectErr}
                                </Typography>
                              )}
                            </Grid2>
                          </Grid2>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {/* Action Buttons */}
                  <Box className={BSstyles.but_card}>
                    <Button
                      className={BSstyles.backBtn}
                      onClick={() => handleBack()}
                    >
                      Back
                    </Button>
                    {bankStatmentFileName ? <Button
                      className={BSstyles.up_button}
                      onClick={() => handleUpload()}
                    >
                   { loading ? "Uploading..." : "Upload"}
                    </Button> : <Button
                      className={BSstyles.grey_button}
                      onClick={() => handleUploadGrey()}
                    >
                     { loading ? "verifying..." : "Upload"}
                    </Button>
                    }
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "Inter400",
                      fontSize: "13px",
                      mt: 4,
                      textAlign: "center",
                      // Responsive media queries
                      '@media (max-width: 1200px)': {
                        fontSize: '14px', // Adjust font size for medium screens
                      },
                      '@media (max-width: 900px)': {
                        fontSize: '12px', // Adjust font size for smaller screens
                        mt: 3, // Adjust margin-top
                      },
                      '@media (max-width: 600px)': {
                        fontSize: '11px', // Smaller font size for mobile
                        mt: 2, // Adjust margin-top
                      },
                    }}
                  >
                    As per SEBI & Exchange regulations, you are required to
                    share your proof of income to enable trading in Futures &
                    Options.
                  </Typography>
                </>
              )}
            </>
          )}
        </>
      </Box>

      <Modal
        open={banknotVerified}  
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontFamily:"Inter400",
              mb: 1,
              color:"#481B9D !important"
            }}
          >
            Activate Futures and Options
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              fontFamily:"Inter400",
              lineHeight: '1.5'
            }}
          >
           Please Link Your Bank account In order to activate Future and options.
          </Typography>
          <Box sx={buttonStyle}>
          
            <button
              style={primaryButton}
              onClick={handleNextStepDoLater} // Or your OK handler
            >
              Do Later
            </button>
            <button
              style={primaryButton}
              onClick={handleNextStep} // Or your OK handler
            >
              Link now
            </button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={opendoLater}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontFamily:"Inter400",
              mb: 1,
              color:"#481B9D !important"
            }}
          >
            Activate Futures and Options
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              fontFamily:"Inter400",
              lineHeight: '1.5'
            }}
          >
            You can activate Future and Options in TradeBoss Backoffice Later.
          </Typography>
          <Box sx={buttonStyle}>
            <button
              style={secondaryButton}
              onClick={handleClose} // Add your click handler
            >
              Do Now
            </button>
            <button
              style={primaryButton}
              onClick={handleNextStepDoLater} // Or your OK handler
            >
              OK
            </button>
          </Box>
        </Box>
      </Modal>

      
      <Modal open={open}>
        <Box className={BSstyles.pwdModal}>
          <Typography className={BSstyles.pwdTitle}>
            {" "}
            Enter Password{" "}
          </Typography>
          <Typography className={BSstyles.pwdBody}>
            Please Provide the password for the Encrypted bank statement file
            uploaded
          </Typography>
          <TextField
            label="Password"
            type="password"
            variant="standard"
            fullWidth
            sx={{
              input: { color: "#999 !important" }, // Ensures input text is visible
              label: { color: "#999 !important" }, // Ensures label is visible
              "& .MuiInput-underline:before": {
                borderBottom: "1px solid black !important", // Normal border color
              },
            }}
            value={password}
             onChange={(e) => setPassword(e.target.value.trim())}
          />
          {passwordEnterErr && (
            <Typography
              // className="upload_tit1"
              sx={{
                fontSize: "12px !important",
                color: "red !important",
              }}
            >
              {passwordEnterErr}
            </Typography>
          )}
          <Grid
            sx={{
              display: "flex !important",
              justifyContent: "flex-end !important",
              marginTop: "20px !important",
            }}
          >
            <Button className={BSstyles.cancelButton} onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              className={BSstyles.submitButton}
              onClick={() => handlePasswordSubmit(password)}
            >
              Submit
            </Button>
          </Grid>
        </Box>
      </Modal>
    </Box>
    </main>
  );
}
